/* tslint:disable */
/* eslint-disable */
/**
 * AI Secretary
 * AI-powered voice assistant platform for automated appointment scheduling, customer communication, and CRM integration
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { PromptTypeResponseDTO } from '../models';
/**
 * PromptsApi - axios parameter creator
 * @export
 */
export const PromptsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get the raw XML template for a specific prompt type.  Returns the unprocessed template file without context injection or wrapper. Requires agent:custom permission for security.  Args:     type_id: The prompt type identifier (e.g., \'beauty\', \'handwerk\', \'autohaus\')  Returns:     Raw XML template content with application/xml content type  Raises:     NotFoundError: If template not found
         * @summary Get Raw Template
         * @param {string} typeId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRawTemplateApiV1PromptsTemplatesTypeIdRawGet: async (typeId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'typeId' is not null or undefined
            assertParamExists('getRawTemplateApiV1PromptsTemplatesTypeIdRawGet', 'typeId', typeId)
            const localVarPath = `/api/v1/prompts/templates/{type_id}/raw`
                .replace(`{${"type_id"}}`, encodeURIComponent(String(typeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the raw XML template for a specific prompt type.  Returns the unprocessed template file without context injection or wrapper. Requires agent:custom permission for security.  Args:     type_id: The prompt type identifier (e.g., \'beauty\', \'handwerk\', \'autohaus\')  Returns:     Raw XML template content with application/xml content type  Raises:     NotFoundError: If template not found
         * @summary Get Raw Template
         * @param {string} typeId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRawTemplateApiV1PromptsTemplatesTypeIdRawGet_1: async (typeId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'typeId' is not null or undefined
            assertParamExists('getRawTemplateApiV1PromptsTemplatesTypeIdRawGet_1', 'typeId', typeId)
            const localVarPath = `/api/v1/prompts/templates/{type_id}/raw`
                .replace(`{${"type_id"}}`, encodeURIComponent(String(typeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all available prompt templates.  Returns metadata about available prompt types without the actual template content. Requires agent:view permission.
         * @summary List Templates
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTemplatesApiV1PromptsTemplatesGet: async (authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/prompts/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all available prompt templates.  Returns metadata about available prompt types without the actual template content. Requires agent:view permission.
         * @summary List Templates
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTemplatesApiV1PromptsTemplatesGet_2: async (authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/prompts/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PromptsApi - functional programming interface
 * @export
 */
export const PromptsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PromptsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get the raw XML template for a specific prompt type.  Returns the unprocessed template file without context injection or wrapper. Requires agent:custom permission for security.  Args:     type_id: The prompt type identifier (e.g., \'beauty\', \'handwerk\', \'autohaus\')  Returns:     Raw XML template content with application/xml content type  Raises:     NotFoundError: If template not found
         * @summary Get Raw Template
         * @param {string} typeId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRawTemplateApiV1PromptsTemplatesTypeIdRawGet(typeId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRawTemplateApiV1PromptsTemplatesTypeIdRawGet(typeId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromptsApi.getRawTemplateApiV1PromptsTemplatesTypeIdRawGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the raw XML template for a specific prompt type.  Returns the unprocessed template file without context injection or wrapper. Requires agent:custom permission for security.  Args:     type_id: The prompt type identifier (e.g., \'beauty\', \'handwerk\', \'autohaus\')  Returns:     Raw XML template content with application/xml content type  Raises:     NotFoundError: If template not found
         * @summary Get Raw Template
         * @param {string} typeId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRawTemplateApiV1PromptsTemplatesTypeIdRawGet_1(typeId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRawTemplateApiV1PromptsTemplatesTypeIdRawGet_1(typeId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromptsApi.getRawTemplateApiV1PromptsTemplatesTypeIdRawGet_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all available prompt templates.  Returns metadata about available prompt types without the actual template content. Requires agent:view permission.
         * @summary List Templates
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTemplatesApiV1PromptsTemplatesGet(authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PromptTypeResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTemplatesApiV1PromptsTemplatesGet(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromptsApi.listTemplatesApiV1PromptsTemplatesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all available prompt templates.  Returns metadata about available prompt types without the actual template content. Requires agent:view permission.
         * @summary List Templates
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTemplatesApiV1PromptsTemplatesGet_2(authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PromptTypeResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTemplatesApiV1PromptsTemplatesGet_2(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromptsApi.listTemplatesApiV1PromptsTemplatesGet_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PromptsApi - factory interface
 * @export
 */
export const PromptsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PromptsApiFp(configuration)
    return {
        /**
         * Get the raw XML template for a specific prompt type.  Returns the unprocessed template file without context injection or wrapper. Requires agent:custom permission for security.  Args:     type_id: The prompt type identifier (e.g., \'beauty\', \'handwerk\', \'autohaus\')  Returns:     Raw XML template content with application/xml content type  Raises:     NotFoundError: If template not found
         * @summary Get Raw Template
         * @param {string} typeId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRawTemplateApiV1PromptsTemplatesTypeIdRawGet(typeId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getRawTemplateApiV1PromptsTemplatesTypeIdRawGet(typeId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the raw XML template for a specific prompt type.  Returns the unprocessed template file without context injection or wrapper. Requires agent:custom permission for security.  Args:     type_id: The prompt type identifier (e.g., \'beauty\', \'handwerk\', \'autohaus\')  Returns:     Raw XML template content with application/xml content type  Raises:     NotFoundError: If template not found
         * @summary Get Raw Template
         * @param {string} typeId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRawTemplateApiV1PromptsTemplatesTypeIdRawGet_1(typeId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getRawTemplateApiV1PromptsTemplatesTypeIdRawGet_1(typeId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all available prompt templates.  Returns metadata about available prompt types without the actual template content. Requires agent:view permission.
         * @summary List Templates
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTemplatesApiV1PromptsTemplatesGet(authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PromptTypeResponseDTO>> {
            return localVarFp.listTemplatesApiV1PromptsTemplatesGet(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all available prompt templates.  Returns metadata about available prompt types without the actual template content. Requires agent:view permission.
         * @summary List Templates
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTemplatesApiV1PromptsTemplatesGet_2(authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PromptTypeResponseDTO>> {
            return localVarFp.listTemplatesApiV1PromptsTemplatesGet_2(authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PromptsApi - object-oriented interface
 * @export
 * @class PromptsApi
 * @extends {BaseAPI}
 */
export class PromptsApi extends BaseAPI {
    /**
     * Get the raw XML template for a specific prompt type.  Returns the unprocessed template file without context injection or wrapper. Requires agent:custom permission for security.  Args:     type_id: The prompt type identifier (e.g., \'beauty\', \'handwerk\', \'autohaus\')  Returns:     Raw XML template content with application/xml content type  Raises:     NotFoundError: If template not found
     * @summary Get Raw Template
     * @param {string} typeId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptsApi
     */
    public getRawTemplateApiV1PromptsTemplatesTypeIdRawGet(typeId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return PromptsApiFp(this.configuration).getRawTemplateApiV1PromptsTemplatesTypeIdRawGet(typeId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the raw XML template for a specific prompt type.  Returns the unprocessed template file without context injection or wrapper. Requires agent:custom permission for security.  Args:     type_id: The prompt type identifier (e.g., \'beauty\', \'handwerk\', \'autohaus\')  Returns:     Raw XML template content with application/xml content type  Raises:     NotFoundError: If template not found
     * @summary Get Raw Template
     * @param {string} typeId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptsApi
     */
    public getRawTemplateApiV1PromptsTemplatesTypeIdRawGet_1(typeId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return PromptsApiFp(this.configuration).getRawTemplateApiV1PromptsTemplatesTypeIdRawGet_1(typeId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all available prompt templates.  Returns metadata about available prompt types without the actual template content. Requires agent:view permission.
     * @summary List Templates
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptsApi
     */
    public listTemplatesApiV1PromptsTemplatesGet(authorization?: string, options?: RawAxiosRequestConfig) {
        return PromptsApiFp(this.configuration).listTemplatesApiV1PromptsTemplatesGet(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all available prompt templates.  Returns metadata about available prompt types without the actual template content. Requires agent:view permission.
     * @summary List Templates
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptsApi
     */
    public listTemplatesApiV1PromptsTemplatesGet_2(authorization?: string, options?: RawAxiosRequestConfig) {
        return PromptsApiFp(this.configuration).listTemplatesApiV1PromptsTemplatesGet_2(authorization, options).then((request) => request(this.axios, this.basePath));
    }
}

